import { useCallback } from 'react';
import { Checkbox, Header, Text, VStack } from '@direct-frontend/components';
import { useConfirm } from '#shared/lib/hooks';
import { constructorTestIds } from '#shared/lib/testids';
import { changeConstructorSectionStatus, getConstructorSectionSettings } from '../model/slices';
import { getConstructorCountChildren } from './useConstructorCountChildren';

export const useConstructorShowSection = () => {
    const { confirm, renderConfirmModal } = useConfirm();

    const showSection = useCallback(
        async (pageId: string, sectionInstanceId: string) => {
            const sectionSettings = getConstructorSectionSettings(pageId, sectionInstanceId);

            if (!sectionSettings) {
                return;
            }

            let showAll = false;

            const { childrenCount } = getConstructorCountChildren({ sectionId: sectionSettings.id });

            if (sectionSettings.section_type === 'parent' && childrenCount > 0) {
                const isConfirmed = await confirm({
                    title: null,
                    bodyText: (
                        <VStack gap="6">
                            <Header level="h2" textAlign="left">
                                Показать родительскую секцию?
                            </Header>
                            <Text size="m" role="supplementary" textAlign="left">
                                В родительской секции находятся настройки всех дочерних секций. Можно показать только её
                                или сразу всю группу
                            </Text>
                            <Checkbox
                                onChange={(isSelected) => (showAll = isSelected)}
                                size="m"
                                data-testid={constructorTestIds.sectionShowComponentShowAll}
                            >
                                <Text>Также показать все дочерние секции</Text>
                            </Checkbox>
                        </VStack>
                    ),
                    applyText: 'Показать',
                    'data-testid': constructorTestIds.sectionShowComponentModal,
                });

                if (!isConfirmed) {
                    return;
                }
            }

            changeConstructorSectionStatus(pageId, sectionInstanceId, 'published', showAll);
        },
        [confirm]
    );

    return { showSection, renderConfirmModal };
};
